module.exports = __webpack_public_path__ + "static/media/8OLA10.96f464ba.jpg";